import { Menu } from "@headlessui/react";

export const CollectionPointsActionMenus = ({
    setAnchorShipmentEl,
    anchorShipmentEl,
    handleWarehouseClick    
}) => {
    return (
        <>
        <Menu as="div" className="relative text-left">
									<div>
										<Menu.Button
											onClick={(e) => setAnchorShipmentEl(e.currentTarget)}
											className="p-2 bg-slate-300 hover:bg-slate-400 text-gray-800 hover:text-gray-900 rounded cursor-pointer"
											title="More Actions..."
										>
											<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
												<path d="M13.5 4.5C13.5 3.67157 12.8284 3 12 3C11.1716 3 10.5 3.67157 10.5 4.5C10.5 5.32843 11.1716 6 12 6C12.8284 6 13.5 5.32843 13.5 4.5Z" stroke="currentColor" stroke-width="1.5" />
												<path d="M13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12Z" stroke="currentColor" stroke-width="1.5" />
												<path d="M13.5 19.5C13.5 18.6716 12.8284 18 12 18C11.1716 18 10.5 18.6716 10.5 19.5C10.5 20.3284 11.1716 21 12 21C12.8284 21 13.5 20.3284 13.5 19.5Z" stroke="currentColor" stroke-width="1.5" />
											</svg>
										</Menu.Button>
									</div>
									{anchorShipmentEl && (
										<Menu.Items className="absolute z-10 ms-3 my-1 bg-white border border-gray-300 rounded shadow-lg p-1 max-h-60 overflow-y-auto" style={{ left: '-180px' }}>
											<div className="px-1 py-1">
												{/* Warehouse Related Actions Section */}
												<Menu.Item>
													{({ active }) => (
														<button
															onClick={() => {
																handleWarehouseClick();
																setAnchorShipmentEl(null);
															}}
															className={`${active ? 'bg-gray-200' : ''
																} group flex rounded-md items-center font-semibold w-full px-1 py-2 text-sm text-black`}
														// title="Go To Warehouse"
														>
															<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 32 32" width="26" height="24">
																<path d="M27.728,16.024l-8.485,8.482l-2.828-2.835L20.071,18H6v-4h14.071l-3.657-3.644l2.828-2.816 L27.728,16.024z" fill="none" stroke="currentColor" stroke-width="2" />
															</svg>
															<span className='mx-3'>Go to Warehouse</span>
														</button>
													)}
												</Menu.Item>
											</div>
										</Menu.Items>
									)}
								</Menu>
        </>
    )
}